import React, { useEffect, useState } from "react";
import { useClasses } from "../../";
import { IDP } from "@maxeb/idp-sdk";
import Login from "./Login";
import Register from "./Register";
import ChallengeEmail from "./ChallengeEmail";
import ChallengePassword from "./ChallengePassword";
import ResetPassword from "./ResetPassword";
import useAuthenticator from "../../hooks/useAuthenticator";
import StateHandler from "../StateHandler";
const styes = (theme) => ({
    block: {
        width: "100%",
        height: "100%",
        borderRadius: "0px",
        backgroundColor: "#fff",
        boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 4px 0px",
        padding: "16px",
        boxSizing: "border-box",
    },
});
let mounted = false;
export default function Authenticator(props) {
    const classes = useClasses(styes);
    const { setSession } = props;
    const translationGroup = props.translationGroup || "authentication";
    const [mode, changeMode] = useState("login");
    const [auth, setAuth] = useAuthenticator();
    const [whoAmI, setWhoAmI] = useState("ok");
    useEffect(() => {
        mounted = true;
        (async () => {
            setWhoAmI("pending");
            try {
                const response = await IDP.whoAMI();
                if (mounted && response.isSuccess()) {
                    setSession(response.getResult().data);
                    setWhoAmI("ok");
                }
            }
            catch (err) {
                if (mounted)
                    setWhoAmI("error");
            }
        })();
        return () => {
            mounted = false;
        };
    }, [setSession]);
    const setMode = (mode, autoLogin) => {
        if (mounted) {
            setAuth({
                ...auth,
                state: "ok",
                errors: {},
                autoLogin: Boolean(autoLogin),
            });
            changeMode(mode);
        }
    };
    return (React.createElement("div", { className: classes.block },
        React.createElement(StateHandler, { state: whoAmI, translationGroup: translationGroup },
            mode === "login" && (React.createElement(Login, { translationGroup: translationGroup, state: auth, setSession: props.setSession, setState: setAuth, onModeChange: setMode })),
            mode === "register" && (React.createElement(Register, { translationGroup: translationGroup, state: auth, setState: setAuth, onModeChange: setMode })),
            mode === "resetPassword" && (React.createElement(ResetPassword, { translationGroup: translationGroup, state: auth, setState: setAuth, onModeChange: setMode })),
            mode === "challengeEmail" && (React.createElement(ChallengeEmail, { translationGroup: translationGroup, state: auth, setState: setAuth, onModeChange: setMode })),
            mode === "challengePassword" && (React.createElement(ChallengePassword, { translationGroup: translationGroup, state: auth, setState: setAuth, onModeChange: setMode })))));
}
